import styled from "@emotion/styled";
import {
  ChangeEvent,
  Dispatch,
  SetStateAction,
  useEffect,
  useState,
} from "react";
import { Customer } from "../../types/types";
import { InfoType } from "./customerModifyModal";
import SelectBox, { menuItemType } from "../selectBox";
import { SelectChangeEvent } from "@mui/material";
import useGetUserGroup from "../../hooks/useGetUserGroup";
import theme from "../../theme";
import { isOnlyNumber } from "../../utils/util";
import { useWindowSize } from "@reactuses/core";
import DaumPost from "../DaumPost";
import { Label } from "../common/Label";
import { TextInput } from "../common/TextInput";
import { useI18n } from "../../locales";
//import { SrLable } from "../common/SrLabel";

const { sm, md } = theme.screen;

const InputField: React.FC<{
  data?: Customer;
  info: InfoType;
  setInfo: Dispatch<SetStateAction<InfoType>>;
  pwError: string;
  setPwError: Dispatch<SetStateAction<string>>;
  checkPwSpace: boolean;
  setCheckPwSpace: any;
  errors: any;
  setErrors: any;
}> = (props) => {
  const {
    data,
    info,
    setInfo,
    pwError,
    setPwError,
    checkPwSpace,
    setCheckPwSpace,
    setErrors,
  } = props;
  const { width } = useWindowSize();
  const [popup, setPopup] = useState(false);
  const { data: GroupOptions } = useGetUserGroup({});
  const { t } = useI18n();

  const userGroupType: menuItemType[] = [];
  if (GroupOptions) {
    for (let i = 0; i < GroupOptions.length; i++) {
      userGroupType.push({
        value: GroupOptions[i].group_id,
        title: GroupOptions[i].name,
      });
    }
  }

  const isValidPassword = (password: string) => {
    if (password.length > 0) {
      const regex =
        /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[!@#$%^&*()_+[\]{};':"\\|,.<>/?-]).{8,}$/;
      return regex.test(password);
    } else return true;
  };

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;

    if (name === "pw" && !isValidPassword(value)) {
      setPwError(
        t.manageCustomer.passwordRequirements
      );
    } else {
      setPwError("");
    }

    if (name === "pw" && value.includes(" ")) {
      setCheckPwSpace(true);
    } else {
      setCheckPwSpace(false);
    }

    if (name == "id") {
      const regexp = /-/g;
      const matches = value.match(regexp);
      if (matches && matches.length > 2) {
        return;
      }
      if (value.replaceAll("-", "").length > 11) {
        return;
      }
      if (!isOnlyNumber(value.replaceAll("-", ""))) {
        return;
      }
    }

    setInfo((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleChangeSelectBox = (event: SelectChangeEvent<String>) => {
    setInfo((prevState) => ({
      ...prevState,
      group_id: event.target.value.toString(),
    }));
  };

  useEffect(() => {
    // console.log("수정하기 인풋 초기 데이터?", data);
    if (data) {
      setInfo({
        seq: data.seq,
        id: data.id,
        pw: "",
        name: data.name,
        phone: data.phone,
        address: data.address,
        address_detail: data.address_detail,
        group_id: data.group_id,
        registered_at: data.registered_at,
        // sex: data.sex,
        // birth: data.birth,
        illness: data.illness,
      });
    }
  }, [data, setInfo]);

  useEffect(() => {
    // // 생년월일 - 입력값 확인 (숫자 6자리)
    // if (!info.birth) {
    //   setErrors((prev: any) => ({ ...prev, birthError: false }));
    // }
    // if (info.birth) {
    //   if (!isOnlyNumber(info.birth) || String(info.birth).length < 6) {
    //     setErrors((prev: any) => ({ ...prev, birthError: true }));
    //   } else if (isOnlyNumber(info.birth)) {
    //     setErrors((prev: any) => ({ ...prev, birthError: false }));
    //   }
    // }

    // // 성별 - 입력값 확인 (숫자 1자리)
    // if (!info.sex) {
    //   setErrors((prev: any) => ({ ...prev, genderError: false }));
    // }
    // if (info.sex) {
    //   if (!isOnlyNumber(info.sex)) {
    //     setErrors((prev: any) => ({ ...prev, genderError: true }));
    //   } else if (isOnlyNumber(info.sex)) {
    //     setErrors((prev: any) => ({ ...prev, genderError: false }));
    //   }
    // }

    // 아이디 (소유자 연락처) - 입력값 확인
    if (!info.id) {
      setErrors((prev: any) => ({ ...prev, idError: false }));
    }
    if (info.id) {
      if (
        info.id.replaceAll("-", "").length == 10 ||
        info.id.replaceAll("-", "").length == 11
      ) {
        setErrors((prev: any) => ({ ...prev, idError: false }));
      } else if (
        info.id.replaceAll("-", "").length < 10 ||
        info.id.replaceAll("-", "").length > 11
      ) {
        setErrors((prev: any) => ({ ...prev, idError: true }));
      }
    }
  }, [info]);

  // console.log("info 변경 확인", info);

  const handleComplete = () => {
    setPopup(!popup);
  };

  return (
    <UserInfoWrapper>
      <UserInfo>
        <FirstRow>
          <InputWrapper>
            <Label text={t.manageCustomer.ownerName} htmlFor="name" isRequired />
            <TextInput
              value={info?.name ?? ""}
              id="name"
              name="name"
              width={"200px"}
              onChange={handleChange}
              placeholder={t.manageCustomer.maxCharacters20}
              minLength={1}
              maxLength={20}
            />
          </InputWrapper>
          <InputWrapper>
            <Label text={t.manageCustomer.ownerContact} htmlFor="id" isRequired />

            <TextInput
              value={info.id ?? ""}
              id="id"
              name="id"
              width={"200px"}
              onChange={handleChange}
            />
            {<HelpText>{t.manageCustomer.includeDash}</HelpText>}
          </InputWrapper>
        </FirstRow>

        {/* 주민번호 + 성별 */}
        {/* <SecondRow>
          <InputWrapper style={{ position: "relative" }}>
            <Label text="주민번호 앞자리" htmlFor="birth" />

            <ResidentNumWrapper>
              <TextInput
                maxLength={6}
                value={info?.birth ?? ""}
                id="birth"
                name="birth"
                width={"200px"}
                onChange={handleChange}
                placeholder="생년월일 입력"
              />
              {errors.birthError && (
                <PwError style={{ position: "absolute", bottom: "-23px" }}>
                  숫자만 6자리 입력해 주세요.
                </PwError>
              )}
              <span>{`-`}</span>
              <BackNumber>
                <SrLable
                  labelText={`주민번호 뒷자리 첫번째 숫자`}
                  id="sex"
                />
                <TextInput
                  maxLength={1}
                  value={info?.sex ?? ""}
                  id="sex"
                  name="sex"
                  width={"50px"}
                  onChange={handleChange}
                  placeholder="숫자"
                />
                {errors.genderError && (
                  <PwError
                    style={{
                      position: "absolute",
                      bottom: "-23px",
                      right: "0",
                    }}
                  >
                    숫자만 1자리 입력해 주세요.
                  </PwError>
                )}
                <span>******</span>
              </BackNumber>
            </ResidentNumWrapper>
          </InputWrapper>
        </SecondRow> */}

        <ThirdRow>
          <InputWrapper style={{ marginBottom: "26px" }}>
            <Label text={t.manageCustomer.address} htmlFor="address" isRequired>
              <PostFindBtn onClick={handleComplete}>
                {t.manageUser.postcodeSearch}
              </PostFindBtn>
            </Label>
            <TextInput
              value={info?.address ?? ""}
              id="address"
              name="address"
              width={"100%"}
              placeholder={t.manageCustomer.addressPlaceholder}
              onChange={handleChange}
              readOnly
            />
          </InputWrapper>
          <InputWrapper style={{ marginBottom: "26px" }}>
            <Label text={t.manageCustomer.detailAddress} htmlFor="address_detail" />

            <TextInput
              value={info?.address_detail ?? ""}
              id="address_detail"
              name="address_detail"
              width={"100%"}
              placeholder={t.manageCustomer.maxCharacters100}
              onChange={handleChange}
            />
          </InputWrapper>
          {/* 우편번호 찾기 */}
          {popup && (
            <DaumPost
              open={popup}
              close={handleComplete}
              setForm={setInfo}
              top={"420px"}
              left={"310px"}
              width={`${width}px`}
            />
          )}
          <FirstRow style={{ gap: 30 }}>
            <InputWrapper>
              <Label text={t.manageCustomer.other} htmlFor="illness" />
              <TextInput
                value={info?.illness ?? ""}
                id="illness"
                name="illness"
                width={"200px"}
                onChange={handleChange}
              />
            </InputWrapper>
            <InputWrapper>
              {/* <Label text="담당기관" htmlFor="illgov_idness" /> */}
              <Label text={t.manageCustomer.groupLabel} htmlFor="illgov_idness" />

              <SelectBox
                filter={info?.group_id || "00000"}
                menuItems={userGroupType}
                width={width <= md ? "100%" : "200px"}
                handleChange={handleChangeSelectBox}
                useSearch
                srLabel={t.manageCustomer.groupSrLabel}
              />
            </InputWrapper>
          </FirstRow>
          <InputWrapper style={{ marginBottom: "26px" }}>
            <Label text={t.manageCustomer.password} htmlFor="pw" />

            <TextInput
              placeholder={t.manageCustomer.passwordPlaceholder}
              id="pw"
              name="pw"
              type="password"
              width={"100%"}
              onChange={handleChange}
              minLength={8}
              value={info.pw ?? ""}
            />
            {pwError && <PwError>{pwError}</PwError>}
            {checkPwSpace && (
              <PwError>{t.manageCustomer.passwordSpaceError}</PwError>
            )}
          </InputWrapper>
          <InputWrapper style={{ marginBottom: "26px" }}>
            <Label text={t.manageCustomer.joinDate} htmlFor="registered_at" />

            <TextInput
              disabled
              defaultValue={data?.registered_at ?? ""}
              id="registered_at"
              name="registered_at"
              width={"100%"}
            />
          </InputWrapper>
          <div style={{ marginLeft: "10px" }}></div>
          <InputWrapper style={{ width: "10px" }}></InputWrapper>
        </ThirdRow>
      </UserInfo>
    </UserInfoWrapper>
  );
};

const UserInfoWrapper = styled.div`
  background: ${theme.color.neutral_50};
  border-radius: 10px;
  padding-left: 40px;
  padding-right: 30px;
  padding-top: 30px;
  padding-bottom: 30px;
  width: 100%;
  display: flex;
  gap: 44px;
  margin-bottom: 40px;

  @media (max-width: ${sm}px) {
    padding: 10px;
  }
`;

const UserInfo = styled.div`
  width: 100%;
`;

const FirstRow = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin-bottom: 26px;

  @media (max-width: ${md}px) {
    flex-direction: column;
    gap: 26px;
  }
`;

// const SecondRow = styled.div`
//   display: flex;
//   width: 100%;
//   justify-content: space-between;
//   margin-bottom: 26px;
// `;

const ThirdRow = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
`;

const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;

  @media (max-width: ${sm}) {
    width: 100%;
  }
  @media (min-width: (${sm + 1})) and (max-width: ${md}) {
    width: 100%;
  }
`;
const PostFindBtn = styled.button`
  margin-left: 10px;
  height: 25px;
  background: ${theme.color.neutral_200};
  border: 1px solid rgb(0, 0, 0, 0);
  border-radius: 5px;
  cursor: pointer;
  color: ${theme.color.neutral_500};
  &:hover {
    border: 1px solid ${theme.color.neutral_400};
  }
  @media (max-width: ${md}px) {
    height: 20px;
    font-size: ${theme.fontSize.FONT_2};
  }
`;

const PwError = styled.p`
  font-size: 10px;
  color: ${theme.color.red_500};
  padding: 5px;
  white-space: pre-line;
`;

// const BackNumber = styled.div`
//   display: flex;
//   gap: 20px;
//   align-items: center;
//   width: 190px;

//   @media (max-width: ${md}px) {
//     gap: 5px;
//   }
// `;

//   @media (max-width: ${md}px) {
//     gap: 5px;
//     width: 100%;

//     span {
//       font-size: 14px;
//     }
//   }
// `;

const HelpText = styled.p`
  font-size: 10px;
  color: ${theme.color.neutral_500};
  /* position: absolute; */
  /* bottom: -30px; */
  left: 3px;
  width: 200px;
  padding-top: 10px;
  padding-left: 10px;
`;
export default InputField;
